import { createContext, useContext } from 'react'

export const CategoryContext = createContext<string>('inicio')

const useCategory = () => useContext(CategoryContext)

export default useCategory
